import { queryOptions } from '@tanstack/react-query'
import { dashboardClient } from '@/api'

export const cardTemplatesQueryOpts = (companyId: string, gameId: string) => {
  return queryOptions({
    queryKey: [gameId, 'card-templates'],
    queryFn: () =>
      dashboardClient.v1
        .getCardTemplates({
          companyId,
          gameId,
        })
        .then(res => res.data),
  })
}
